var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('SearchForm',{on:{"search":_vm.search}}),(_vm.videos.length > 0)?_c('SearchResults',{attrs:{"videos":_vm.videos,"reformattedSearchString":_vm.reformattedSearchString,"placeKey":_vm.placeKey,"roomNo":_vm.roomNo}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }